<template>
  <nav role="navigation">
    <ul class="grid w-full grid-cols-8 justify-between md:gap-4 lg:gap-6">
      <li>
        <navigation-item
          active-class="bg-purple-lighter text-white"
          exact
          label="Framsida"
          to="/"
          :icon="IconHome"
        ></navigation-item>
      </li>
      <li>
        <navigation-item
          active-class="bg-peach-base text-white"
          label="Djurfakta"
          to="/djurfakta"
          :icon="IconWhale"
        ></navigation-item>
      </li>
      <li>
        <navigation-item
          active-class="bg-green-base text-white"
          label="Hjälp djuren"
          to="/hjalp-djuren"
          :icon="IconChick"
        ></navigation-item>
      </li>
      <li>
        <navigation-item
          active-class="bg-blue-base text-white"
          label="Klubbnytt"
          to="/klubbnytt"
          :icon="IconMagazine"
        ></navigation-item>
      </li>
      <li>
        <navigation-item
          active-class="bg-green-dark text-white"
          label="App"
          to="/app"
          :icon="IconMobilePhone"
        ></navigation-item>
      </li>
      <li>
        <navigation-item
          active-class="bg-pink-base text-white"
          label="Om oss"
          to="/om-oss"
          :icon="IconAboutUs"
        ></navigation-item>
      </li>
      <li>
        <navigation-item
          active-class="bg-purple text-white"
          label="För vuxna"
          to="/vuxen"
          :icon="IconAdults"
        ></navigation-item>
      </li>
      <li>
        <navigation-item
          active-class="bg-pink-dark text-white"
          label="Bli medlem"
          to="/medlem"
          :icon="IconBecomeMember"
        ></navigation-item>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import IconAboutUs from '@/components/icons/IconAboutUs.vue'
import IconAdults from '@/components/icons/IconAdults.vue'
import IconBecomeMember from '@/components/icons/IconBecomeMember.vue'
import IconChick from '@/components/icons/IconChick.vue'
import IconHome from '@/components/icons/IconHome.vue'
import IconMagazine from '@/components/icons/IconMagazine.vue'
import IconMobilePhone from '@/components/icons/IconMobilePhone.vue'
import IconWhale from '@/components/icons/IconWhale.vue'
</script>
